import axios from 'axios';
import lib from '@/lib';
import FingerprintJS from '@fingerprintjs/fingerprintjs';

export default class AuthModel
{
	/**
	 * Конструктор
	 */
	constructor()
	{
		// Инициализация
		this.authChecked = false;
		this.token = lib.localStorageGet('token')||'';
		this.refresh_token = lib.localStorageGet('refresh_token')||'';
		this.device_id = lib.localStorageGet('device_id')||'';
		
		this.userProfile = null;
		this.userPermissions = [];
		this.userKeychains = [];
		this.userAccounts = [];
		
		if (this.token) {
			axios.defaults.headers.common['Authorization'] = `Bearer ${this.token}`;
		}
		if (this.refresh_token) {
			axios.defaults.headers.common['Refresh-Token'] = this.refresh_token;
		}
		if (this.device_id) {
			axios.defaults.headers.common['Device-ID'] = this.device_id;
		} else {
			this.doSetFingerprint();
		}
		axios.defaults.headers.common['Content-Type'] = 'application/json';
	}
	
	async doSetFingerprint()
	{
		try {
			const fp = await FingerprintJS.load();
        	const result = await fp.get();
			this.device_id = result.visitorId;
			lib.localStorageSet('device_id', this.device_id, 0);
			axios.defaults.headers.common['Device-ID'] = this.device_id;
		} catch (error) {
			console.error('Ошибка получения отпечатка:', error);
		}
	}
	
	/**
	 * Проверка на включенность двухфакторной аутентификации у пользователя
	 */
	async doCheck2fa(username)
	{
		try {
			const response = await axios.get('/api/auth/check-2fa', {
				params: {
					lang: storeInstance.state.app.getLang(),
					username,
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error){
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					error: error.message,
				};
			}
		}
	}
	
	/**
	 * Инициализация данных пользователя
	 */
	async doInitData()
	{
		if (!this.authChecked && this.token) {
			try {
				const response = await axios.get('/api/user/get-init-data', {
					params: {
						lang: storeInstance.state.app.getLang(),
					},
					mode: 'cors',
					cache: 'no-cache',
					withCredentials: true,
				});
				this.setUserProfile(response.data.user_data);
				this.userPermissions = response.data.user_permissions || [];
				this.userKeychains = response.data.user_keychains || [];
				this.userAccounts = response.data.user_accounts || [];
				this.authChecked = true;
			} catch (error) {
				console.error(error);
				if (error.response) {
					return {
						success: false,
						...error.response.data,
					};
				} else {
					return {
						success: false,
						error: error.message,
					};
				}
			}
		}
		return {
			success: true,
		};
	}
	
	/**
	 * Авторизация
	 */
	async doLogin(username, password, google2fa_code)
	{
		try {
			const response = await axios.post('/api/auth/login', {
				lang: storeInstance.state.app.getLang(),
				username,
				password,
				google2fa_code,
			}, {
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			const data = response.data;
			if (data.error && data.error !== '') {
				console.error(data.error || '');
				this.userProfile = null;
				this.userPermissions = [];
				this.userKeychains = [];
				this.userAccounts = [];
				lib.localStorageRemove('token');
				lib.localStorageRemove('refresh_token');
				this.token = '';
				this.refresh_token = '';
				delete axios.defaults.headers.common['Authorization'];
				delete axios.defaults.headers.common['Refresh-Token'];
				this.authChecked = false;
				return {
					success: false,
					code: data.code,
					error: data.error,
				};
			}
			const token = data.token;
			const refresh_token = data.refresh_token;
			lib.localStorageSet('token', token, 0);
			lib.localStorageSet('refresh_token', refresh_token, 0);
			this.token = token;
			this.refresh_token = refresh_token;
			axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
			axios.defaults.headers.common['Refresh-Token'] = refresh_token;
			this.setUserProfile(data.user_data);
			this.userPermissions = data.user_permissions || [];
			this.userKeychains = data.user_keychains || [];
			this.userAccounts = data.user_accounts || [];
			this.authChecked = true;
			return {
				success: true,
			};
		} catch (error) {
			console.error(error);
			this.userProfile = null;
			this.userPermissions = [];
			this.userKeychains = [];
			this.userAccounts = [];
			lib.localStorageRemove('token');
			lib.localStorageRemove('refresh_token');
			this.token = '';
			this.refresh_token = '';
			delete axios.defaults.headers.common['Authorization'];
			delete axios.defaults.headers.common['Refresh-Token'];
			this.authChecked = false;
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					error: error.message,
				};
			}
		}
	}
	
	/**
	 * Авторизация через соцсети
	 */
	async socialLogin(provider, code)
	{
		try {
			const response = await axios.post(`/api/social-auth/${provider}/callback`, {
				lang: storeInstance.state.app.getLang(),
				code,
			}, {
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			const data = response.data;
			if (data.error && data.error !== '') {
				console.error(data.error || '');
				this.userProfile = null;
				this.userPermissions = [];
				this.userKeychains = [];
				this.userAccounts = [];
				lib.localStorageRemove('token');
				lib.localStorageRemove('refresh_token');
				this.token = '';
				this.refresh_token = '';
				delete axios.defaults.headers.common['Authorization'];
				delete axios.defaults.headers.common['Refresh-Token'];
				this.authChecked = false;
				return {
					success: false,
					error: data.error,
				};
			}
			const token = data.token;
			const refresh_token = data.refresh_token;
			lib.localStorageSet('token', token, 0);
			lib.localStorageSet('refresh_token', refresh_token, 0);
			this.token = token;
			this.refresh_token = refresh_token;
			axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
			axios.defaults.headers.common['Refresh-Token'] = refresh_token;
			this.setUserProfile(data.user_data);
			this.userPermissions = data.user_permissions || [];
			this.userKeychains = data.user_keychains || [];
			this.userAccounts = data.user_accounts || [];
			this.authChecked = true;
			return {
				success: true,
			};
		} catch (error) {
			console.error(error);
			this.userProfile = null;
			this.userPermissions = [];
			this.userKeychains = [];
			this.userAccounts = [];
			lib.localStorageRemove('token');
			lib.localStorageRemove('refresh_token');
			this.token = '';
			this.refresh_token = '';
			delete axios.defaults.headers.common['Authorization'];
			delete axios.defaults.headers.common['Refresh-Token'];
			this.authChecked = false;
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					error: error.message,
				};
			}
		}
	}
	
	/**
	 * Продление токена
	 */
	async doRefreshToken()
	{
		const refresh_token = this.refresh_token;
		try {
			const response = await axios.post('/api/auth/refresh-token', {}, {
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
				headers: {
					'Refresh-Token': refresh_token,
				}
			});
			const newToken = response.data.token;
			this.token = newToken;
			lib.localStorageSet('token', newToken, 0);
			axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
			return newToken;
		} catch (error) {
			console.error('Ошибка обновления токена:', error);
			this.token = '';
			this.refresh_token = '';
			lib.localStorageRemove('token');
			lib.localStorageRemove('refresh_token');
			delete axios.defaults.headers.common['Authorization'];
			delete axios.defaults.headers.common['Refresh-Token'];
			throw error;
		}
	}
	
	/**
	 * Проверка токена на наличие в черном списке
	 * 
	 */
	async doCheckTokenBlacklist(token)
	{
		try {
			const response = await axios.post('/api/auth/check-token-blacklist', {
				token,
			}, {
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data.blacklisted;
		} catch (error) {
			console.error('Ошибка проверки черного списка', error);
			return false; // Предположим, что токен не в черном списке при ошибке
		}
	}
	
	/**
	 * Проверка сессии на ее существование
	 * 
	 */
	async doCheckSession()
	{
		try {
			const response = await axios.post('/api/auth/check-session', {
				user_id: this.getUserId(),
				device_id: this.device_id,
			}, {
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data.valid;
		} catch (error) {
			console.error('Ошибка проверки сессии', error);
			return false; // Предположим, что токен не в черном списке при ошибке
		}
	}
	
	/**
	 * Деавторизация
	 */
	async doLogout()
	{
		try {
			await axios.post('/api/auth/logout', {}, {
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			this.userProfile = null;
			this.userPermissions = [];
			this.userKeychains = [];
			this.userAccounts = [];
			lib.localStorageRemove('token');
			lib.localStorageRemove('refresh_token');
			this.token = '';
			this.refresh_token = '';
			delete axios.defaults.headers.common['Authorization'];
			delete axios.defaults.headers.common['Refresh-Token'];
			this.authChecked = false;
			return true;
		} catch (error) {
			console.error(error);
			this.userProfile = null;
			this.userPermissions = [];
			this.userKeychains = [];
			this.userAccounts = [];
			lib.localStorageRemove('token');
			lib.localStorageRemove('refresh_token');
			this.token = '';
			this.refresh_token = '';
			delete axios.defaults.headers.common['Authorization'];
			delete axios.defaults.headers.common['Refresh-Token'];
			this.authChecked = false;
			return false;
		}
	}
	
	/**
	 * Регистрация пользователя
	 */
	async doRegister(params = {})
	{
		try {
			const response = await axios.post('/api/auth/register', {
				lang: storeInstance.state.app.getLang(),
				login: params.login,
				email: params.email,
				password1: params.password1,
				password2: params.password2,
				captcha: params.captcha || '',
				captcha_type: params.captcha_type || '',
			}, {
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					error: error.message,
				};
			}
		}
	}
	
	/**
	 * Восстановление пароля через api
	 * шаг 1
	 */
	async doRecoveryPasswordStep1(params = {})
	{
		try {
			const response = await axios.post('/api/auth/recovery-password-step1', {
				lang: storeInstance.state.app.getLang(),
				username: params.username || '',
				captcha: params.captcha || '',
				captcha_type: params.captcha_type || '',
			}, {
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					error: error.message,
				};
			}
		}
	}
	
	/**
	 * Восстановление пароля через api
	 * шаг 2
	 */
	async doRecoveryPasswordStep2(params = {})
	{
		try {
			const response = await axios.post('/api/auth/recovery-password-step2', {
				lang: storeInstance.state.app.getLang(),
				username: params.username || '',
				code: params.code || '',
				password1: params.password1 || '',
				password2: params.password2 || '',
			}, {
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					error: error.message,
				};
			}
		}
	}
	
	/**
	 * Подтверждение email через api
	 * шаг 1
	 */
	async doConfirmEmailStep1(params = {})
	{
		try {
			const response = await axios.post('/api/auth/confirm-email-step1', {
				lang: storeInstance.state.app.getLang(),
				username: params.username || '',
				captcha: params.captcha || '',
				captcha_type: params.captcha_type || '',
			}, {
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					error: error.message,
				};
			}
		}
	}
	
	/**
	 * Подтверждение email через api
	 * шаг 2
	 */
	async doConfirmEmailStep2(params = {})
	{
		try {
			const response = await axios.post('/api/auth/confirm-email-step2', {
				lang: storeInstance.state.app.getLang(),
				username: params.username || '',
				code: params.code || '',
			}, {
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					error: error.message,
				};
			}
		}
	}
	
	/**
	 * Изменение анкетных данных через api
	 * ava - новая аватарка
	 * sname - фамилия
	 * fname - имя
	 * lname - отчество
	 * gender - пол
	 * dateofbirth - дата рождения
	 */
	async doChangeQuestionary(ava, sname, fname, lname, gender, dateofbirth)
	{
		let params = {
			lang: storeInstance.state.app.getLang(),
			sname,
			fname,
			lname,
			gender,
			dateofbirth,
		};
		if (ava != this.getAvatarLink()) {
			params['ava'] = ava;
		}
		try {
			const response = await axios.post('/api/user/change-questionary', params, {
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					error: error.message,
				};
			}
		}
	}
	
	/**
	 * Смена логина через api
	 * login - новый логин
	 */
	async doChangeLogin(login)
	{
		try {
			const response = await axios.post('/api/user/change-login', {
				lang: storeInstance.state.app.getLang(),
				login,
			}, {
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					error: error.message,
				};
			}
		}
	}
	
	/**
	 * Смена email через api
	 * email - новый email
	 */
	async doChangeEmail(email)
	{
		try {
			const response = await axios.post('/api/user/change-email', {
				lang: storeInstance.state.app.getLang(),
				email,
			}, {
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					error: error.message,
				};
			}
		}
	}
	
	/**
	 * Смена пароля через api
	 * password1 - новый пароль
	 * password2 - повтор нового пароля
	 */
	async doChangePassword(password1, password2)
	{
		try {
			const response = await axios.post('/api/user/change-password', {
				lang: storeInstance.state.app.getLang(),
				password1,
				password2,
			}, {
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					error: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение данных для включения двухфакторной аутентификации через api
	 */
	async doGet2faData()
	{
		try {
			const response = await axios.get('/api/user/get-2fa', {
				params: {
					lang: storeInstance.state.app.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					error: error.message,
				};
			}
		}
	}
	
	/**
	 * Включение двухфакторной аутентификации через api
	 * secret - secret key
	 * code - код из приложения-аутентификатора
	 */
	async doEnable2fa(secret, code)
	{
		try {
			const response = await axios.post('/api/user/enable-2fa', {
				lang: storeInstance.state.app.getLang(),
				secret,
				code,
			}, {
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					error: error.message,
				};
			}
		}
	}
	
	/**
	 * Выключение двухфакторной аутентификации через api
	 */
	async doDisable2fa()
	{
		try {
			const response = await axios.delete('/api/user/disable-2fa', {
				data: {
					lang: storeInstance.state.app.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					error: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение соцсетей из ключницы
	 */
	async getKeychains()
	{
		try {
			const response = await axios.get('/api/user/keychain', {
				params: {
					lang: storeInstance.state.app.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					error: error.message,
				};
			}
		}
	}
	
	/**
	 * Добавление соцсети в ключницу
	 */
	async doAddKeychain(provider, code)
	{
		try {
			const response = await axios.post(`/api/user/keychain/${provider}`, {
				lang: storeInstance.state.app.getLang(),
				code,
			}, {
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					error: error.message,
				};
			}
		}
	}
	
	/**
	 * Удаление соцсети из ключницы
	 */
	async doDeleteKeychain(provider, keychain_id)
	{
		try {
			const response = await axios.delete(`/api/user/keychain/${provider}/${keychain_id}`, {
				data: {
					lang: storeInstance.state.app.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					error: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение истории авторизаций пользователя
	 */
	async getAuthHistory(start)
	{
		try {
			const response = await axios.get('/api/user/auth-history', {
				params: {
					lang: storeInstance.state.app.getLang(),
					start,
					limit: 10,
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					error: error.message,
				};
			}
		}
	}
	
	/**
	 * Получение активных сессий
	 */
	async getActiveSessions()
	{
		try {
			const response = await axios.get('/api/user/active-sessions', {
				params: {
					lang: storeInstance.state.app.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					error: error.message,
				};
			}
		}
	}
	
	/**
	 * Удаление активной сессии
	 */
	async doDeleteActiveSession(id)
	{
		try {
			const response = await axios.delete('/api/user/active-sessions/' + id, {
				data: {
					lang: storeInstance.state.app.getLang(),
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					error: error.message,
				};
			}
		}
	}
	
	/**
	 * Удаление аккаунта через api
	 * password - текущий пароль
	 */
	async doDeleteAccount(password)
	{
		try {
			const response = await axios.delete('/api/user/delete-account', {
				data: {
					lang: storeInstance.state.app.getLang(),
					password,
				},
				mode: 'cors',
				cache: 'no-cache',
				withCredentials: true,
			});
			return response.data;
		} catch (error) {
			console.error(error);
			if (error.response) {
				return {
					success: false,
					...error.response.data,
				};
			} else {
				return {
					success: false,
					error: error.message,
				};
			}
		}
	}
	
	isAuth()
	{
		return this.token != '' && this.userProfile != null;
	}
	
	isAdmin()
	{
		return this.hasPermission('account.bylex.superadmin');
	}
	
	getVirtualSpaces()
	{
		return this.userAccounts.filter((el) => el.virtualspace_id != null);
	}
	
	/**
	 * Получение виртуального пространства по его id
	 */
	getVirtualSpace(id)
	{
		return this.userAccounts.find((el) => el.virtualspace_id == id);
	}
	
	getUserId()
	{
		return this.userProfile != null ? this.userProfile.user_id : '';
	}
	
	getLogin()
	{
		return this.userProfile != null ? this.userProfile.login : '';
	}
	
	getSname()
	{
		return this.userProfile != null ? this.userProfile.sname : '';
	}
	
	getFname()
	{
		return this.userProfile != null ? this.userProfile.fname : '';
	}
	
	getLname()
	{
		return this.userProfile != null ? this.userProfile.lname : '';
	}
	
	getGender()
	{
		return this.userProfile != null ? this.userProfile.gender : '';
	}
	
	getDateOfBirth()
	{
		return this.userProfile != null ? this.userProfile.dateofbirth : '';
	}
	
	getEmail()
	{
		return this.userProfile != null ? this.userProfile.email : '';
	}
	
	getAvatarLink()
	{
		return this.userProfile != null ? 'https://id.bylex.su' + this.userProfile.ava : '';
	}
	
	hasPermission(permission_api_name, virtualspace_id = null)
	{
		if (Object.values(this.userPermissions).length > 0) {
			if (virtualspace_id) {
				return !!(Object.values(this.userPermissions).find(elem => elem.virtualspace_id == virtualspace_id && elem.permissions.includes(permission_api_name)));
			} else {
				return !!(Object.values(this.userPermissions).find(elem => elem.permissions.includes(permission_api_name)));
			}
		}
		return false;
	}
	
	/**
	 * Устанавливает user profile
	 */
	setUserProfile(res)
	{
		if (res == null) {
			this.userProfile = null;
		} else {
			this.userProfile = {
				user_id: res.id,
				login: res.login,
				sname: res.sname,
				fname: res.fname,
				lname: res.lname,
				gender: res.gender,
				dateofbirth: res.dateofbirth,
				email: res.email,
				ava: res.avatar,
				google2fa_secret: res.google2fa_secret,
			};
		}
	}
}
